import styled from 'styled-components'

const Container = styled.div`
	max-width: ${p => p.theme.maxWidth};
	width: 100%;
	margin: 0 auto;
	padding: 0 1rem;
`

export default Container
